module.exports = __webpack_public_path__ + "static/media/background.6b71a147.jpg";